'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _helpers = require('@adparlor-devops/js-anvil/helpers');

var _selectors = require('../../../../store/selectors');

var _ruleset = require('../modules/ruleset');

var _Ruleset = require('../components/Ruleset');

var _Ruleset2 = _interopRequireDefault(_Ruleset);

var _constants = require('../../../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    ruleset: (0, _selectors.getRulesets)(state),
    isPackage: state.session.isPackage,
    currentAdvertiser: (0, _selectors.getCurrentAdvertiserObject)(state),
    frequencies: _constants.FREQUENCIES
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    rulesetsActions: (0, _helpers.buildActionsCollection)({
      update: _ruleset.updateRuleset,
      delete: _ruleset.deleteRuleset,
      create: _ruleset.createRuleset,
      updatePriorities: _ruleset.updateRulesetPriorities
    }, dispatch),
    rulesActions: (0, _helpers.buildActionsCollection)({
      update: _ruleset.updateRule,
      duplicate: _ruleset.duplicateRule,
      delete: _ruleset.deleteRule,
      fetch: _ruleset.fetchRules
    }, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Ruleset2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Ruleset/containers/RulesetContainer.js
// module id = 3682
// module chunks = 3